'use client';

import { useUserContext } from '@/context/user';
import Image from 'next/image';
import Link from 'next/link';
import type { MouseEvent } from 'react';
import { toast } from 'sonner';
import classes from './banner.module.css';

const SHOP_LINK = '/mens-boots/';
const JOIN_LINK = '/create-account';

export const Banner = () => {
  // 这里不用 new-vip 的 useCreateAccountOrSignIn：它内部调 useSearchParams()，
  // 会让本页 build 时报 missing-suspense-with-csr-bailout；而给 banner 套 Suspense
  // 又会让首屏大图退出 SSR、拖垮 LCP。改为直接读登录态，跳转交给 <Link> 原生完成。
  const [{ isSignedIn }] = useUserContext();

  const handleJoin = (e: MouseEvent) => {
    if (isSignedIn) {
      e.preventDefault();
      toast.success('You are already logged in');
    }
  };

  return (
    <div className='w-full bg-[#F86949]'>
      {/* PC：直接使用设计稿整图，按钮以热区形式盖在图上 */}
      <div className={`hidden lg_block ${classes.stage}`}>
        <Image
          src='/double-rewards/banner.webp'
          alt='Double Rewards. October 20–30. Every order earns you 2X reward points.'
          width={5760}
          height={1952}
          priority
          // 源图本身就是压好的 webp（5760 宽仅 123KB），再过一次 next 的有损优化
          // （默认 quality 75）反而会把文字和线条压糊，这里直接原图输出
          unoptimized
          sizes='100vw'
          className='h-full w-full'
        />

        <Link
          href={JOIN_LINK}
          onClick={handleJoin}
          className={`${classes.hotspot} ${classes.join} font-roboto-medium`}
        >
          Join Free &amp; Start Earning
        </Link>

        <Link
          href={SHOP_LINK}
          className={`${classes.hotspot} ${classes.shop} font-roboto-medium`}
        >
          Shop Now, Points Doubled
        </Link>
      </div>

      {/* 移动端：整图文字会小到看不清，改为徽章 + 文案纵向排版 */}
      <div className='flex flex-col items-center px-[12px] py-[20px] lg_hidden'>
        <Image
          src='/double-rewards/badge.webp'
          alt='2X reward points on every order'
          width={1465}
          height={1665}
          priority
          sizes='160px'
          className='h-auto w-[160px]'
        />

        <h1 className='mt-[14px] w-full font-teko-medium text-[34px] font-medium uppercase leading-[34px] text-white'>
          Double Rewards.
          <br />
          October 20–30.
        </h1>

        <p className='mt-[12px] w-full font-roboto-regular text-[15px] leading-[24px] text-black'>
          Every order earns you <span className='font-roboto-medium'>2X</span> reward points. Gear
          up for hunting &amp; fall work — and get twice the rewards while you do it.
        </p>

        <div className='mt-[14px] flex w-full flex-col gap-[10px]'>
          <Link
            href={JOIN_LINK}
            onClick={handleJoin}
            className='flex h-[44px] items-center justify-center whitespace-nowrap rounded-full bg-black px-[30px] font-roboto-medium text-[16px] text-white'
          >
            Join Free &amp; Start Earning
          </Link>

          <Link
            href={SHOP_LINK}
            className='flex h-[44px] items-center justify-center whitespace-nowrap rounded-full bg-white px-[30px] font-roboto-medium text-[16px] text-black'
          >
            Shop Now, Points Doubled
          </Link>
        </div>
      </div>
    </div>
  );
};
